
import Vue from "vue";
import SubscribeMixin from "~/mixin/subscribe-mixin";
import { butter } from "../plugins/buttercms";
import schemaArticle from "~/utils/articleSchema.js";
import FormatMixin from "~/mixin/format-mixin";
import ProductFetchMixin from "~/mixin/product-fetch-mixin";
import DeliveryWeekMixin from "~/mixin/delivery-week-mixin";
import Product from "~/types/Product";
import ProductMapMixin from "~/mixin/product-map-mixin";
import CitySelection from "~/components/filter-section/cal-city-section.vue";
import DeliveryDateSelection from "~/components/filter-section/cal-delivery-date-selection.vue";
import CalDeliveryDateSelection from "../components/filter-section/cal-delivery-date-selection.vue";
import OccationSelector from "~/components/filter-section/cal-occation-selection.vue";

export default Vue.extend({
  name: "IndexPage",
  mixins: [
    SubscribeMixin,
    FormatMixin,
    ProductFetchMixin,
    DeliveryWeekMixin,
    ProductMapMixin,
  ],
  computed: {
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
  },
  data() {
    return {
      bouquetLoading: false,
      pageData: {},
      form: {
        name: "",
        email: "",
        phone: "",
      },
      alertMessage: "",
      showAlert: false,
      metaTags: null,
      enableBazzarV: true,
      mainCarouselSchema: [],
      articleSchemaStructure: schemaArticle,
      isValidForm: false,
      isFormSent: false,
      flowersList: [],
      landingDateCode: "",
      deliveryDate: sessionStorage.deliveryDate
        ? sessionStorage.deliveryDate
        : "",
      deliveryTown: sessionStorage.deliveryTown
        ? JSON.parse(sessionStorage.deliveryTown)
        : {},
      occasion: sessionStorage["occasion"] ? sessionStorage["occasion"] : "",
    };
  },
  components: {
    CitySelection,
    DeliveryDateSelection,
    CalDeliveryDateSelection,
    OccationSelector,
  },
  async created() {
    await this.getFlowersList();

    this.$nuxt.$on("cityUpdated", async () => {
      this.deliveryTown = JSON.parse(sessionStorage.getItem("deliveryTown"));
      await this.getFlowersList();
    });

    this.$nuxt.$on("deliveryDateUpdated", async () => {
      this.deliveryDate = sessionStorage.deliveryDate;
      await this.getFlowersList();
    });
  },
  async fetch() {
    try {
      const page = await butter(this.$config).page.retrieve(
        "home_page",
        "home",
        {
          locale: this.$i18n.locale,
          timeout: 10000,
        }
      );
      this.pageData = page?.data.data.fields;
      this.metaTags = this.pageData.seo;
      this.setupMainCarouselSchema(page);
    } catch (error) {
      console.error(error);
    }
  },
  watch: {
    "form.email"() {
      this.checkFormValid();
    },
    "form.name"() {
      this.checkFormValid();
    },
    "form.phone"() {
      this.checkFormValid();
    },
  },
  methods: {
    getCity(city) {
      this.deliveryTown = city;
      sessionStorage.setItem("deliveryTown", JSON.stringify(this.deliveryTown));
      this.deliveryDate = sessionStorage.deliveryDate;
    },
    getDeliveryDate(deliveryDate) {
      this.deliveryDate = deliveryDate;
      sessionStorage.deliveryDate = this.deliveryDate;
    },
    getOccasion(occasion) {
      this.occasion = occasion;
      sessionStorage.occasion = occasion;
    },
    checkFormValid() {
      this.isValidForm =
        this.isEmailValid(this.form.email) &&
        this.isValidFormName(this.form.name) &&
        this.isPhoneNumberValid(this.form.phone);
    },

    closeAlertDialog() {
      this.form.name = "";
      this.form.email = "";
      this.form.phone = "";
      this.showAlert = false;
    },
    async submit() {
      try {
        if (!this.isFormSent) {
          this.isFormSent = true;
          await this.subscribe(
            this.$axios,
            this.form.name,
            this.form.email,
            this.$i18n.locale.split("-"),
            this.form.phone,
            (this.alertMessage =
              this.$t("success_message1") +
              this.form.name +
              this.$t("success_message2"))
          );
        }
      } catch (error) {
        console.error(error);
        this.isFormSent = false;
      }
      this.showAlert = true;
    },
    setupMainCarouselSchema(page) {
      this.pageData["cal-carousel"].slides.forEach((slide) => {
        let articleSchema = { ...this.articleSchemaStructure };
        articleSchema.image = [...(this.articleSchemaStructure.image || [])];
        articleSchema.headline = slide.heading;
        articleSchema.description = slide.paragraph;
        articleSchema.image.push(slide.image);
        articleSchema.mainEntityOfPage["@id"] = "https://callia.com/en-ca";
        articleSchema.datePublished = page?.data.data.published;
        articleSchema.dateModified = page?.data.data.updated;
        this.mainCarouselSchema.push(articleSchema);
      });
    },
    async getFlowersList() {
      try {
        this.bouquetLoading = true;
        this.flowersList = [];
        if (this.deliveryDate && this.deliveryDate.length > 0) {
          this.landingDateCode = this.selectWeekNumber(this.deliveryDate);
        } else {
          this.landingDateCode = this.selectWeekNumber(
            this.$dayjs().format("YYYY-MM-DD")
          );
        }
        const productData = await this.getProductDataFromCMS();
        await this.getLandingBouquets(this.landingDateCode);
        sessionStorage.productList = "";
        this.bouquetResponse.forEach((element) => {
          let handle = element?.handle;
          if (handle) {
            sessionStorage.productList +=
              handle.substring(0, handle.indexOf("_")) + " ";
          }
          let product = new Product(element, productData);
          this.flowersList.push(product);
        });
        this.flowersList = this.flowersList
          ? this.flowersList.filter(
              (item) =>
                !item.tags.includes("centrepiece") &&
                !item.tags.includes("dried-bouquet")
            )
          : this.flowersList;
        this.flowersList = this.sortProductsByStyle(this.flowersList);
      } catch (error) {
        console.error(error);
      }
      this.bouquetLoading = false;
    },
    async getProductDataFromCMS() {
      try {
        const products = await butter(this.$config).content.retrieve(
          ["products"],
          {
            locale: this.$i18n.locale,
            timeout: 10000,
          }
        );
        return products?.data.data.products;
      } catch (error) {
        console.error(error);
      }
    },
  },
});
